



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Select } from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import { ISmartBlock, TestResultParams } from './types';
import SmartStatItem from './components/item';

@Component({
  components: {
    Button,
    Select,
    SmartStatItem,
  },
})
export default class SmartBlock extends Vue implements ISmartBlock {
  @Prop({ type: Array, default: () => [] })
  readonly smartItems!: TestResultParams;

  @Prop({ type: Boolean, default: false })
  readonly hasTestResults!: boolean;

  @Prop({ type: Array, default: () => [] })
  readonly testsForSelect!: TestResultParams;

  @Prop({ type: Number, default: 0 })
  readonly selectedSmartStatId!: number;

  get selectInitValue(): TestResultParams {
    const { testsForSelect, selectedSmartStatId } = this;
    return testsForSelect.find(item => item.id === selectedSmartStatId);
  }

  testResultSelected(result: TestResultParams): void {
    this.$emit('testResultSelected', result);
  }

  startTest(): void {
    this.$emit('startTest');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/SmartBlock.vue